import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SharedModule } from "../../../../shared.module";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'amount-cell',
    templateUrl: './amount-renderer.component.html',
    standalone: true,
    imports: [SharedModule, CommonModule]
})
export class AmountRendererComponent implements ICellRendererAngularComp {
    public amount: number;
    public displayAmount: boolean = true;
    public buttonClass: string = "display-none";
    public buttonTooltip: string;
    public removeComma: boolean = true;
    constructor() {}

    initilize(params: ICellRendererParams) {
        this.amount = params.getValue();
        this.removeComma = (params as any).removeComma ?? true;
        if (params && params.data) {
            if (params.data.buttonClass && params.colDef && params.colDef.headerComponentParams) {
                if (params.colDef.headerComponentParams.displayOnlyIcon) {
                    this.buttonClass = params.data.buttonClass;
                    this.buttonTooltip = params.data.buttonTooltip;
                    this.displayAmount = false;
                }
                else {
                    this.buttonClass = "display-none";
                }

            }
            else {
                this.buttonClass = "display-none";
            }
        }
        else {
            this.buttonClass = "display-none";
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
